import React, { forwardRef, useEffect, useImperativeHandle } from 'react';
import { useIntl } from 'react-intl';
import { Controller, FormProvider, useFieldArray, useForm } from 'react-hook-form';
import classNames from 'classnames';
import { requiredInput } from '../../../core/formValidation';

const InventoryTypeForm = forwardRef(({ initialValues = {}, onSubmit }, ref) => {
  const intl = useIntl();
  const methods = useForm({ defaultValues: { types: [{}], ...initialValues } });
  const { control, handleSubmit } = methods;
  const { fields, append, remove } = useFieldArray({ name: 'types', control });

  useEffect(() => {
    if (!fields || fields.length === 0) {
      append({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useImperativeHandle(ref, () => ({
    submit: () => handleSubmit((vals) => onSubmit && onSubmit(vals))(),
  }));

  return (
    <FormProvider {...methods}>
      <div className="inline-add-item-button">
        {fields.map((field, index) => (
          <div key={field.id} className="field-row">
            <div className="field-row-heading">
              <p>{`Type #${index + 1}`}</p>
              {index > 0 && (
                <button
                  type="button"
                  className={classNames('close', 'no-float', 'multi-form-delete')}
                  onClick={() => remove(index)}
                >
                  <i className="icon icon-squared-cross" />
                </button>
              )}
            </div>
            <div className="form-group">
              <Controller
                name={`types.${index}.name`}
                render={({ field: ctl }) =>
                  requiredInput({
                    input: ctl,
                    id: 'name',
                    type: 'text',
                    className: 'form-control row-padding',
                    'aria-describedby': 'descriptionHelp',
                    placeholder: intl.formatMessage({ id: 'name' }),
                  })
                }
              />
            </div>
          </div>
        ))}
        <button
          type="button"
          className={classNames('button')}
          data-testid="addTypeButton"
          onClick={() => append({})}
        >
          {intl.formatMessage({ id: 'addInventoryType' })}
        </button>
      </div>
    </FormProvider>
  );
});

export default InventoryTypeForm;
